import { natsRequestTimeout, natsTabInactiveRequestTimeout } from "@/model/Settings";
import { useClientStore } from "@/store/client";
import { isBrowserTabActive } from "@/utils/dom/dom";
import type { UnknownRecord } from "@/utils/type";

export interface CallContext extends UnknownRecord {
  base: string;
  path: string;
  args: unknown[];
  kwargs?: UnknownRecord;
  correlationId: string;
  tabActiveBefore: boolean;
  requestTimeout: number;
  issuedAt: string;
  retry?: number;
}

export function createCallContext(
  base: string,
  path: string,
  args: unknown[],
  kwargs?: UnknownRecord,
  timeout?: number,
  retry?: number,
): CallContext {
  return {
    base,
    path,
    args,
    kwargs,
    correlationId: useClientStore().newCorrelationId(),
    tabActiveBefore: isBrowserTabActive(),
    requestTimeout:
      timeout || (isBrowserTabActive() ? natsRequestTimeout : natsTabInactiveRequestTimeout),
    issuedAt: new Date().toISOString(),
    retry,
  };
}

export function createCallHeaders(context: CallContext) {
  return {
    "correlation-id": context.correlationId,
    client_version: "20220428r0",
    issued_at: context.issuedAt,
  };
}
